import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../api/client";
import { Mail } from "lucide-react";

export default function EmailInbox() {
    const [emails, setEmails] = useState([]);
    const [sel, setSel] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const r = await api.get("/emails/mine");
                setEmails(r.data);
                if (r.data.length) setSel(r.data[0]);
            } catch (_) {}
        })();
    }, []);

    return (
        <div className="min-h-screen bg-ink-300 text-silver-100">
            <Navbar />
            <section className="max-w-[1400px] mx-auto px-4 md:px-10 pt-14 pb-28">
                <div className="flex items-center gap-3 mb-3 text-[11px] tracking-[0.3em] text-silver-400 uppercase">
                    <Mail className="w-4 h-4" /> Inbox · Platform notifications
                </div>
                <h1 className="font-display text-5xl md:text-6xl leading-none mb-10">
                    Your deal <span className="silver-text italic">timeline.</span>
                </h1>

                <div className="grid md:grid-cols-[360px_1fr] gap-6">
                    <div className="border border-white/10 rounded-sm overflow-hidden" data-testid="inbox-list">
                        {emails.length === 0 && <div className="p-6 text-silver-500 text-sm">No notifications yet.</div>}
                        {emails.map((e) => (
                            <button
                                key={e.id}
                                onClick={() => setSel(e)}
                                className={`w-full text-left p-4 border-b border-white/5 transition-colors ${sel?.id === e.id ? "bg-white/5" : "hover:bg-white/5"}`}
                            >
                                <div className="text-[11px] tracking-widest uppercase text-silver-500 mb-1">
                                    {new Date(e.sent_at).toLocaleString()}
                                </div>
                                <div className="text-sm text-silver-200 truncate">{e.subject}</div>
                            </button>
                        ))}
                    </div>
                    <div className="border border-white/10 rounded-sm p-6 min-h-[300px]" data-testid="inbox-view">
                        {sel ? (
                            <>
                                <div className="text-[11px] tracking-[0.3em] uppercase text-silver-500 mb-3">{sel.kind}</div>
                                <div className="font-display text-2xl md:text-3xl mb-4">{sel.subject}</div>
                                <div className="prose prose-invert max-w-none text-silver-300 text-sm" dangerouslySetInnerHTML={{ __html: sel.html }} />
                            </>
                        ) : (
                            <div className="text-silver-500 text-sm">Select a message.</div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}
